import { Component } from '@angular/core';
import { BaseEdit } from '../base-edit';

@Component({
    selector: 'ldw-select-edit',
    templateUrl: './select-edit.component.html',
    styleUrls: ['./select-edit.component.css'],
    standalone: false
})
export class SelectEditComponent extends BaseEdit {
  get valueList(): string[] {
    if (!this.isBound) {
      return [];
    }
    // @ts-ignore value can not be undefined, as we check it with isBound
    return this._vmp.valueList;
  }
}
